const selectors = {
  routinesList: (state) => state.routines.routinesList,
  currentRoutine: (state) => state.routines.currentRoutine,
};

export { selectors };
